var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgWorkatoLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4247 10.1818C30.4147 11.7841 29.9381 13.9051 28.3429 14.9053C27.2806 15.5727 26.002 15.5636 24.9697 15.0327L24.9691 15.0334L24.9525 15.0261L24.9353 15.0188C24.841 14.979 24.7424 14.9488 24.5703 14.9226C24.383 14.8939 24.1713 14.9141 23.9356 14.9831L23.9239 14.9865C23.8091 15.0277 23.6954 15.0831 23.5866 15.1534C22.9061 15.5843 22.6926 16.4873 23.1064 17.1704L24.6868 19.7287C25.6769 21.3309 25.2001 23.4519 23.605 24.4522C22.0191 25.4524 19.9197 24.9707 18.9296 23.3593L17.3805 20.8493C16.9496 20.1547 16.042 19.9417 15.3635 20.3771C14.928 20.652 14.6809 21.1268 14.676 21.6126V21.6272C14.676 22.7757 14.1168 23.8964 13.0809 24.5447C11.4949 25.5451 9.39563 25.0634 8.40552 23.4518L2.57501 13.8173C1.58504 12.215 2.06166 10.0941 3.65681 9.09388C5.24283 8.09353 7.34209 8.57519 8.33221 10.1867L9.89061 12.9122C10.3172 13.5998 11.211 13.8154 11.8871 13.3972L11.9074 13.3844C12.3384 13.1159 12.5767 12.5291 12.595 12.0568C12.5767 10.8898 13.1451 9.75049 14.1902 9.09289C15.7761 8.09267 17.8754 8.57436 18.8656 10.1858L20.4331 12.8473C20.864 13.5419 21.7716 13.755 22.4499 13.3195C22.6098 13.2182 22.7583 13.0433 22.8953 12.7948C22.842 12.8961 22.8468 12.8858 22.9098 12.7643C23.0043 12.5822 23.0652 12.4379 23.0924 12.3318C23.1186 12.2291 23.1379 12.1298 23.1501 12.0341C23.2742 10.7221 23.7173 9.74614 24.7493 9.08895C26.3352 8.0886 28.4346 8.5703 29.4247 10.1818Z",
    fill: "#67EADD"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgWorkatoLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/workato-logo.e1e40c591ebd1e4650b00882f6611fe7.svg";